import { render, staticRenderFns } from "./listado_de_gestiones_ingresadas_por_sector_en_proceso_aprobada_denegada_y_cancelada.vue?vue&type=template&id=e947eae4&scoped=true"
import script from "./listado_de_gestiones_ingresadas_por_sector_en_proceso_aprobada_denegada_y_cancelada.vue?vue&type=script&lang=js"
export * from "./listado_de_gestiones_ingresadas_por_sector_en_proceso_aprobada_denegada_y_cancelada.vue?vue&type=script&lang=js"
import style0 from "./listado_de_gestiones_ingresadas_por_sector_en_proceso_aprobada_denegada_y_cancelada.vue?vue&type=style&index=0&id=e947eae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e947eae4",
  null
  
)

export default component.exports